<template lang="html">
    <div>
        <section class="main-content-section">
            <tl-tabs :tabs="tabs">
                <tl-tab>
                    <monthly-payslips @stepNum="$emit('stepNum',4)"></monthly-payslips>
                </tl-tab>
                <tl-tab>
                    <fnf-payslips @stepNum="$emit('stepNum',4)"></fnf-payslips>
                </tl-tab>
            </tl-tabs>
        </section>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MonthlyPayslips from "./MonthlyPayslips.vue";
import FnfPayslips from "./FnfPayslips.vue";

export default {
  name: "Payslips",
  components: {
    MonthlyPayslips,
    FnfPayslips
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    })
  },
  data() {
    return {
      tabs: [
        {
          header: "Monthly Payslip"
        },
        {
          header: "FnF Payslip"
        }
      ]
    };
  },
  mounted() {},

  methods: {
    ...mapActions({})
  }
};
</script>

<style lang="scss" scoped>
</style>